const MESSAGE_SELECTORS = [
    '#paypal-commerce-proddetails-messaging-banner',
    '#paypal-commerce-cart-messaging-banner',
];

const PRICE_SELECTORS = {
    '#paypal-commerce-proddetails-messaging-banner': [
        '.productView-details--header .productView-price [data-product-price-with-tax]',
        '.productView-details--header .productView-price [data-product-price-without-tax]',
        '.productView-details.buy-section .productView-price [data-product-price-with-tax]',
        '.productView-details.buy-section .productView-price [data-product-price-without-tax]',
    ],
    '#paypal-commerce-cart-messaging-banner': [
        '.cart-total-grandTotal',
        '.cart-total-value--grand-total',
    ],
};

function keepMessageRegionsVisible() {
    const styleId = 'b2b-paypal-message-visibility';
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
        body [data-content-region="product_below_price"],
        body [data-content-region="cart_below_totals"] {
            display: block !important;
        }
    `;
    document.head.appendChild(style);
}

function parseAmount(value) {
    if (!value) return null;

    const normalized = value.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    const amount = parseFloat(normalized);

    return Number.isFinite(amount) && amount > 0 ? amount.toFixed(2) : null;
}

function findAmount(selectors) {
    for (let i = 0; i < selectors.length; i += 1) {
        const candidates = document.querySelectorAll(selectors[i]);

        for (let j = 0; j < candidates.length; j += 1) {
            const candidate = candidates[j];
            const amount = parseAmount(candidate.textContent);

            if (amount && candidate.getClientRects().length) return amount;
        }
    }

    return null;
}

function syncMessageAmount() {
    MESSAGE_SELECTORS.forEach(selector => {
        const message = document.querySelector(selector);
        if (!message) return;

        const amount = findAmount(PRICE_SELECTORS[selector]);
        if (!amount || message.getAttribute('data-pp-amount') === amount) return;

        message.setAttribute('data-pp-amount', amount);
    });
}

export default function initPayPalPayLater() {
    keepMessageRegionsVisible();
    syncMessageAmount();

    let syncQueued = false;
    const observer = new MutationObserver(() => {
        if (syncQueued) return;

        syncQueued = true;
        window.requestAnimationFrame(() => {
            syncQueued = false;
            syncMessageAmount();
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
    });
}
